export default "query listTop10RelateUnitName($name: String) {\n  listTop10RelateUnitName(name: $name) \n}";